module.exports = __webpack_public_path__ + "img/fb.6c736389.svg";